import type { MediaSetting } from "@circle-react/types/MediaSetting";
import { VideoPlayer } from "../../VideoPlayer";

interface MediaPreviewProps {
  mediaSettings: MediaSetting;
}

export const MediaPreview = ({ mediaSettings }: MediaPreviewProps) => (
  <div className="flex w-full justify-center">
    <div className="w-full max-w-3xl">
      <VideoPlayer
        src={mediaSettings.blob_url}
        contentType={mediaSettings.blob_content_type}
        mediaTranscoding={mediaSettings.transcoding}
        mediaTranscriptId={mediaSettings.transcript?.id ?? undefined}
        downloadUrl={mediaSettings.blob_url}
        downloadable={mediaSettings.make_downloadable}
        settingsEnabled={false}
        posterUrl={
          mediaSettings.custom_thumbnail_url ??
          mediaSettings.default_thumbnail_url
        }
        variants={mediaSettings.video_variants}
        signedId={mediaSettings.blob_signed_id}
      />
    </div>
  </div>
);
